import React from 'react'
import PropTypes from 'prop-types'

export const CategoryButtonGroup = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="flex rounded-full overflow-hidden border-2 border-white shadow-[0_0_4px_rgba(0,0,0,0.3)]">
      {categories.map((category, index) => {
        const firstClass = index === 0 ? 'rounded-l-full' : '-ml-px'
        const lastClass = index === categories.length - 1 ? 'rounded-r-full' : ''
        const selectedClass =
          selectedCategory === category.key ? 'bg-house-blue' : 'hover:bg-gray-100'

        return (
          <button
            key={category.key}
            onClick={() => onCategoryChange(category.key)}
            title={category.label}
            className={`w-20 h-10 border border-white bg-soft-gray flex items-center justify-center xs:text-xl font-medium text-house-text-gray transition-all
              ${firstClass} ${lastClass} ${selectedClass}`}
          >
            {category.label}
          </button>
        )
      })}
    </div>
  )
}

CategoryButtonGroup.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedCategory: PropTypes.string.isRequired,
  onCategoryChange: PropTypes.func.isRequired
}
